import PricingPreview from "./PricingPreview";

export default PricingPreview;
